import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { FadeIn } from './FadeIn';
import { Link } from 'react-router-dom';
export function Pricing() {
  const ref = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], ['-15%', '15%']);
  return <section id="pricing" ref={ref} className="relative py-32 md:py-44 text-white overflow-hidden" data-id="element-140">
      {/* Parallax Background Image */}
      <motion.div className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url("https://code-11.hr/wp-content/uploads/2025/05/2G6A7666-scaled.jpg")',
      y,
      scale: 1.2
    }} data-id="element-141">
        <div className="absolute inset-0 bg-charcoal/75" data-id="element-142" />
      </motion.div>

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-143">
        <FadeIn data-id="element-144">
          <div className="max-w-3xl mx-auto text-center flex flex-col items-center" data-id="element-145">
            <span className="text-copper font-sans uppercase tracking-[0.2em] text-xs mb-6 block" data-id="element-146">
              Investment
            </span>
            <motion.div className="h-[1px] bg-copper mb-10" initial={{
            width: 0
          }} whileInView={{
            width: 32
          }} viewport={{
            once: true
          }} transition={{
            duration: 1,
            delay: 0.5,
            ease: [0.21, 0.47, 0.32, 0.98]
          }} data-id="element-147" />
            <h2 className="text-3xl md:text-5xl font-serif font-normal mb-8 leading-tight" data-id="element-148">
              Tailored Packages for <br data-id="element-149" />
              <span className="italic text-white/70" data-id="element-150">Every Love Story</span>
            </h2>
            <p className="font-script text-2xl md:text-3xl text-copper mb-10" data-id="element-151">
              Diamond premium booking
            </p>
            <p className="font-sans text-white/60 max-w-xl mx-auto font-light text-base leading-relaxed mb-14" data-id="element-152">
              From intimate gatherings to grand celebrations, our wedding
              experiences are crafted with care. Discover our curated packages
              and see how we can bring your vision to life on the shores of
              Hvar.
            </p>

            <Link to="/weddings-pricing" className="group inline-flex items-center gap-3 px-10 py-5 border border-copper text-copper hover:bg-copper hover:text-charcoal transition-all duration-500 font-sans text-xs uppercase tracking-[0.2em]" data-id="element-153">
              <span data-id="element-154">View Prices & Details</span>
              <ArrowRight className="w-4 h-4 transition-transform duration-500 group-hover:translate-x-1" strokeWidth={1.5} data-id="element-155" />
            </Link>

            <p className="text-white/40 font-sans text-xs italic mt-10 font-light" data-id="element-156">
              All packages can be customized to your preferences.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}